import { z } from 'zod';

const createEntryInputSchema = z.object({
  fieldChanges: z
    .array(
      z.object({
        fieldId: z.string().min(1),
        value: z
          .unknown()
          .refine((value) => value !== undefined, { message: 'value is required' })
      })
    )
    .optional()
});

export const createEntrySchema = createEntryInputSchema.optional();

export const createEntryIfAbsentSchema = createEntryInputSchema.extend({
  entryId: z.string().uuid('entryId must be a valid UUID')
});
